import { isEqual } from 'lodash';


export const compare = (defaultValues, current) => {
  const cur = { workSchedule: { ...current.workSchedule } };
  if (current.restrictions) {
    cur.restrictions = {
      ...current.restrictions,
      locations: current.allowedLocations || [],
    };
  }

  if (current.bankHours) {
    cur.bankHours = { ...current.bankHours };
  }

  let df;
  if (defaultValues) {
    df = {
      workSchedule: {
        workScale: defaultValues.ScheduleForm.scheduleId,
        dtRef: defaultValues.ScheduleForm.scheduleStartDate,
      },
    };

    if (defaultValues.RestrictionsForm.dtRef) {
      df.restrictions = { ...defaultValues.RestrictionsForm };
    }

    if (defaultValues.BankOfHoursForm && defaultValues.BankOfHoursForm.dtFrom) {
      df.bankHours = {
        initialValue: defaultValues.BankOfHoursForm.initialValue,
        dtFrom: defaultValues.BankOfHoursForm.dtFrom,
        dtTo: defaultValues.BankOfHoursForm.dtTo,
        disableCurrent: false,
        cumulativeHoursLimit: defaultValues.BankOfHoursForm.cumulativeHoursLimit,
      };
    }
  } else {
    df = {};
  }

  // console.log(df.workSchedule, cur.workSchedule);
  // console.log({
  //   schedule: isEqual(df.workSchedule, cur.workSchedule),
  //   bank: isEqual(df.bankHours, cur.bankHours),
  //   restrictions: isEqual(df.restrictions, cur.restrictions),
  // });

  return {
    schedule: isEqual(df.workSchedule, cur.workSchedule),
    bank: isEqual(df.bankHours, cur.bankHours),
    restrictions: isEqual(df.restrictions, cur.restrictions),
  };
};
